import React from 'react'

import classNames from 'classnames'

import styles from './UseCasesItem.module.scss'
import { Link } from 'gatsby'
import { ReactComponent as ArrowSVG } from './ArrowSVG.svg'

import { isLocalLink } from '../../../helpers/url'
import { navAttrs } from '../../../helpers/navClickTracking'

interface UseCasesItemProps {
  bottomLinkUrl: string
  bottomLinkText: string
  isDarkMode?: boolean
  navSection?: string
}

function UseCasesItem({ bottomLinkUrl, bottomLinkText, isDarkMode, navSection }: UseCasesItemProps) {
  const trackingAttrs = navSection ? navAttrs('top', navSection, bottomLinkText) : {}
  return (
    <>
      {isLocalLink(bottomLinkUrl) ? (
        <Link
          to={bottomLinkUrl}
          className={classNames(styles.root, { [styles.darkRoot]: isDarkMode })}
          {...trackingAttrs}
        >
          <div className={styles.bottomLink}>
            <span>{bottomLinkText}</span>
            <ArrowSVG className={styles.arrow} />
          </div>
        </Link>
      ) : (
        <a
          href={bottomLinkUrl}
          className={classNames(styles.root, { [styles.darkRoot]: isDarkMode })}
          rel='noreferrer'
          {...trackingAttrs}
        >
          <div className={styles.bottomLink}>
            <span>{bottomLinkText}</span>
            <ArrowSVG className={styles.arrow} />
          </div>
        </a>
      )}
    </>
  )
}

export default UseCasesItem
